window.addEventListener('load', function (event) {
    const tabs = document.querySelectorAll('.benefits-tabbed-section__tab--single');

    const swiper = new Swiper('.benefits-tabbed-section__tabs_wrapper', {
        wrapperClass: 'benefits-tabbed-section__tabs_track',
        slideClass: 'benefits-tabbed-section__tab--single',
        speed: 500,
        slidesPerView: 'auto',
        slideToClickedSlide: true,
        breakpoints: {
            320: {},
            768: {},
            1024: {}
        },
        allowTouchMove: false, 
        on: {
            slideChangeTransitionEnd: function () {
                updateBulletVisibility(this.slides, this.activeIndex);
            }
        }
    });

    tabs.forEach((tab, index) => {
        tab.querySelector('.benefits-tabbed-section__tab--single_wrapper').addEventListener('click', () => {
            swiper.slideTo(index);
            updateBulletVisibility(tabs, index);
        });
    });

    let timer;  
    let currentIndex = 0;  
    const slides = document.querySelectorAll('.slide');

    function updateBulletVisibility(slides, activeIndex) {
        clearTimeout(timer);

        slides.forEach((slide, index) => {
            const bullets = slide.querySelector('.benefits-tabbed-section__tab--bullets');
            if (index === activeIndex) {
                bullets.style.display = 'block';
                slide.classList.add('current_slide');
            } else {
                bullets.style.display = 'none';
                slide.classList.remove('current_slide');
            }
        });

        currentIndex = activeIndex;

        timer = setTimeout(() => {
            const nextIndex = (currentIndex + 1) % slides.length;

            updateBulletVisibility(slides, nextIndex);
        }, 12000); 
    }

    updateBulletVisibility(slides, 0);


    updateBulletVisibility(tabs, 0);

}, false);
